import todoData from "./data";

export default todoData;
